import Page from "components/page/Page";
import React, { useState } from "react";
import { useWebsiteBuilderLauncher } from "./useWebsiteBuilderLauncher";
import { useTranslation } from "react-i18next";

export default function WebsiteBuilderLogoAndBrand() {
  const { t } = useTranslation();
  const websiteBuilderLauncher = useWebsiteBuilderLauncher();

  const [websiteExists] = useState<boolean>(false);

  return (
    <Page
      narrow
      title={t("Logo & Brand")}
      subtitle={t("Manage your website, pages, and domain.")}
      primaryAction={{
        content: websiteBuilderLauncher.launchWebsiteBuilderContent(websiteExists),
        action: () => websiteBuilderLauncher.launchWebsiteBuilder(websiteExists),
      }}
      multipleActionDropdownAction={{
        label: t("Quick actions"),
        dropdownProps: {
          alignment: "right",
          options: [
            {
              type: "handler",
              label: "",
              handler: () => {},
              icon: undefined,
            },
          ],
        },
      }}
    ></Page>
  );
}
